import { Injectable } from '@angular/core';
import {
  ConfirmDialogComponent,
  AlertDialogComponent,
  InputDialogComponent,
  LoadingDialogComponent
} from '../component/alert';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class AlertService {
  loadingRef: any;

  constructor(public dialog: MatDialog) {}

  confirm(options: ConfirmModel) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px'
    });
    dialogRef.componentInstance.title = options.title;
    dialogRef.componentInstance.message = options.message;
    dialogRef.componentInstance.confirmText = options.confirmText || 'CONFIRM';
    dialogRef.componentInstance.confirmColor =
      options.confirmColor || 'primary';
    dialogRef.componentInstance.cancelText = options.cancelText || 'Cancel';

    dialogRef.afterClosed().subscribe(result => {
      options.callback(result);
    });
  }

  alert(options: AlertModel) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '400px'
    });
    dialogRef.componentInstance.title = options.title || 'Heads Up!';
    dialogRef.componentInstance.message = options.message;
    dialogRef.componentInstance.confirmText = options.confirmText || 'OK';
    dialogRef.componentInstance.confirmColor =
      options.confirmColor || 'primary';

    dialogRef.afterClosed().subscribe(result => {
      if (options.callback) {
        options.callback(result);
      }
    });
  }

  input(options: InputModel) {
    const dialogRef = this.dialog.open(InputDialogComponent, {
      width: '400px'
    });
    dialogRef.componentInstance.title = options.title;
    dialogRef.componentInstance.message = options.message;
    dialogRef.componentInstance.confirmText = options.confirmText || 'CONFIRM';
    dialogRef.componentInstance.confirmColor =
      options.confirmColor || 'primary';
    dialogRef.componentInstance.cancelText = options.cancelText || 'Cancel';

    dialogRef.afterClosed().subscribe(result => {
      options.callback(result);
    });
  }

  startLoading(message?: string) {
    this.loadingRef = this.dialog.open(LoadingDialogComponent, {
      width: '350px'
    });
    this.loadingRef.componentInstance.message = message
      ? message
      : 'Loading...';
    this.loadingRef.disableClose = true;
  }

  stopLoading() {
    if (this.loadingRef) {
      this.loadingRef.close();
    }
  }

  close() {
    this.dialog.closeAll();
  }
}

export class AlertModel {
  title?: string;
  message: string;
  confirmText?: string;
  confirmColor?: string;
  callback?: (result: boolean) => any;
}

export class ConfirmModel {
  title: string;
  message: string;
  confirmText?: string;
  confirmColor?: string;
  cancelText?: string;
  callback: (result: boolean) => any;
}

export class InputModel {
  title: string;
  message: string;
  confirmText?: string;
  confirmColor?: string;
  cancelText?: string;
  callback: (result: boolean) => any;
}
